export const RESOURCE_TYPES = ['Snape', 'Mesh']